import React from 'react'
import { Form } from 'react-bootstrap'

const CreateUser = () => {
  return (
    <div className='m-1 px-2 py-5'
	style={{ 
		backgroundColor: 'whitesmoke',
		height: '99vh'
	 }}
	>
		<h4><b className=" mb-5">Create New User </b></h4> 
      <div className="card">
		<div className="card-body">
			<form action="" id="newUser">
				<input type="hidden" name="id" />
				<div className="row">
					<div className="col-md-6 border-right">
						<b className="text-muted">Personal Information</b>
						<div className="form-group">
							<label for="" className="control-label">Name</label>
							<input type="text" name="name" className="form-control form-control-sm" required />
						</div>
						<div className="form-group">
							<label className="control-label">Email</label>
							<input type="email" className="form-control form-control-sm" name="email" required />
							<small id="#msg"></small>
						</div>
						<div className="form-group">
							<label for="" className="control-label">Phone</label>
							<input type="text" name="phone" className="form-control form-control-sm" required />
						</div>
						<div className="form-group">
							<label className="control-label">Username</label>
							<input type="text" className="form-control form-control-sm" name="username"  />
							
						</div>
						<div className="form-group">
							<label className="control-label">Address </label>
							<input type="text" className="form-control form-control-sm" name="address" />
							
						</div>
					</div>
					<div className="col-md-6">
					<b className="text-muted">Defaults Access Key/Type </b>
						<div className="form-group">
							<label for="" className="control-label">User Type</label>
							<Form.Select size='sm' name="type" id="type" className="form-control">
								<option value="3" >Select user Type... </option>
								<option value="3" >Regular</option>
								<option value="2" >Agent</option>
								<option value="1"> Admin </option>
							</Form.Select>
							<small><i></i></small>
						</div>
						<div className="form-group">
							<label className="label control-label">Create Password</label>
							<input type="password" className="form-control form-control-sm" name="password" />
							<small id="pass_match" data-status=''></small>
						</div>
						<div className="form-group">
							<label className="label control-label">Confirm Password</label>
							<input type="password" className="form-control form-control-sm" name="cpassword" />
							<small id="pass_match" data-status=''></small>
						</div>
					</div>
				</div>
				<hr />
				<div className="col-lg-12 text-right justify-content-center d-flex">
					{/* <input type='submit' className="btn btn-color mr-2" id="submit-btn"
					
					value="Save" /> */}
					 <button className="btn btn-danger btn-lg w-25" type="button" onClick="location.href = 'index.php?page=user_list'">Cancel</button>
					 <button className="btn btn-dark ms-2 w-25">Save</button> 
					
				</div>
			</form>
		</div>
	</div>
    </div>
  )
}

export default CreateUser